export default __webpack_public_path__ + "static/media/cw-8h.8021e37d.png";